export default {
  data: {
    shareEmails: null
  },
  methods: {
    sendEmails() {
      // const emails = this.shareEmails;

      // const route = Kadenze.Routes.send_referrals_path({ emails });

      // const urlParams = {
      //   url: route,
      //   loadingIndicator: {
      //     container: this.$el
      //   }
      // };

      // const req = new Kadenze.AjaxRequest(urlParams);
      // req.done(() => {
        Kadenze.Notice.success({title: 'This feature is not available for now.'});
      // });
    }
  }
};